<template>
  <page-tabs
      :tabs="[
        {label:'Записи', name:'medRecords', perm:'medrecordsRecord', path:'/medRecord/record/'},
        {label:'Заявки в лабораторию', name:'labRequests', perm:'medrecordsLabrequest', path:'/medRecord/labRequest/'},
    ]"
  >
    <template v-slot:default="{tabSelected}">
      <med-records v-if="tabSelected==='medRecords' && mountedDelay"/>
      <lab-requests v-if="tabSelected==='labRequests' && mountedDelay"/>
    </template>
  </page-tabs>
</template>
<script>
import MedRecords from "@/views/MedRecord/MedRecords.vue";
import LabRequests from "@/views/MedRecord/LabRequests.vue";
import mounted from "@/mixins/mounted";
import PageTabs from "@/componentsV2/base/PageTabs.vue";

export default {
  components: {PageTabs,LabRequests, MedRecords},
  mixins:[mounted],
  watch:{
    $route(){
      this.$nextTick(()=>{
        if(typeof this.$refs.callGroups!=='undefined')
          this.$refs.callGroups.externalTrigger();
      })
    }
  },
}
</script>